import {
  convertIosStringToDateDayjs,
  formatToCurrencyType,
} from "helper/common";
import { FIELD_TYPE } from "types/enums";
import { ColumnsEdit } from "types/models/column-table-edit";
import { DataFormField } from "types/models/input-field-type";
const { DATE_DISABLE, SELECT, INPUT, COMBO_BOX } = FIELD_TYPE;

const allStoreFields: DataFormField[] = [
  {
    label: "Kho",
    type: COMBO_BOX,
    allowClear: true,
    name: "khoId",
  },
  {
    label: "Tên",
    type: INPUT,
    allowClear: true,
    name: "name",
  },
  {
    label: "Mã vật tư",
    type: INPUT,
    allowClear: true,
    name: "vtId",
  },

  {
    label: "Thời gian từ",
    type: DATE_DISABLE,

    name: "start",
  },
  {
    label: "Thời gian đến",
    type: DATE_DISABLE,
    name: "end",
  },
];

const allReportAllColums: ColumnsEdit = [
  {
    title: "STT",
    key: "1",
    dataIndex: "stt",
    fixed: "left",
    width: 40,
    align: "center",
  },
  {
    title: "Mã HH/VT",
    key: "maHang",
    dataIndex: "maHang",
    align: "center",
    width: 100,
  },
  {
    title: "Tên HH/VT",
    key: "tenHang",
    dataIndex: "tenHang",
    align: "left",
    width: 150,
  },
  {
    title: "Kho",
    key: "kho",
    dataIndex: "kho",
    align: "left",
    width: 150,
  },
  {
    title: "Đơn vị tính",
    key: "donViTinh",
    dataIndex: "donViTinh",
    align: "left",
    width: 100,
  },
  {
    title: "Tồn đầu kỳ",
    children: [
      {
        title: "SL",
        width: 50,
        align: "right",
        key: "soLuongTonDau",
        dataIndex: "soLuongTonDau",
      },
      {
        title: "Thành tiền",
        width: 100,
        align: "right",
        key: "thanhTienTonDau",
        dataIndex: "thanhTienTonDau",
        render: (v) => formatToCurrencyType(v),
      },
    ],
  },
  {
    title: "Nhập",
    children: [
      {
        title: "Mua",
        children: [
          {
            title: "SL",
            dataIndex: "soLuongMua",
            width: 50,
            key: "soLuongMua",
            align: "right",
          },
          {
            align: "right",
            title: "Thành tiền",
            dataIndex: "thanhTienMua",
            width: 100,
            render: (v) => formatToCurrencyType(v),
            key: "thanhTienMua",
          },
        ],
      },
      {
        title: "Chuyển kho nội bộ",
        children: [
          {
            title: "SL",
            dataIndex: "soLuongNhapNoiBo",
            width: 50,
            align: "right",
            key: "soLuongNhapNoiBo",
          },
          {
            title: "Thành tiền",
            dataIndex: "thanhTienNhapNoiBo",
            width: 100,
            render: (v) => formatToCurrencyType(v),
            align: "right",
            key: "thanhTienNhapNoiBo",
          },
        ],
      },
      {
        title: "BN trả hàng",
        children: [
          {
            title: "SL",
            dataIndex: "soLuongNhapBNTraHang",
            width: 50,
            align: "right",
            key: "soLuongNhapBNTraHang",
          },
          {
            title: "Thành tiền",
            dataIndex: "thanhTienNhapBNTraHang",
            width: 100,
            render: (v) => formatToCurrencyType(v),
            align: "right",
            key: "thanhTienNhapBNTraHang",
          },
        ],
      },
      {
        title: "Khác",
        children: [
          {
            title: "SL",
            dataIndex: "soLuongKhacNhap",
            width: 50,
            align: "right",
            key: "soLuongKhacNhap",
          },
          {
            title: "Thành tiền",
            dataIndex: "thanhTienKhacNhap",
            width: 100,
            render: (v) => formatToCurrencyType(v),
            align: "right",
            key: "thanhTienKhacNhap",
          },
        ],
      },
    ],
  },
  {
    title: "Xuất",
    align: "left",
    children: [
      {
        title: "Bán",
        dataIndex: "ban",
        children: [
          {
            title: "SL",
            dataIndex: "soLuongBan",
            width: 50,
            align: "right",
            key: "soLuongBan",
          },
          {
            title: "Thành tiền",
            dataIndex: "thanhTienBan",
            key: "thanhTienBan",
            align: "right",
            width: 100,
            render: (v) => formatToCurrencyType(v),
          },
        ],
      },
      {
        title: "Chuyển kho nội bộ",
        children: [
          {
            title: "SL",
            dataIndex: "soLuongXuatNoiBo",
            align: "right",
            key: "soLuongXuatNoiBo",
            width: 50,
          },
          {
            title: "Thành tiền",
            dataIndex: "thanhTienXuatNoiBo",
            ket: "thanhTienXuatNoiBo",
            align: "right",
            width: 100,
            render: (v) => formatToCurrencyType(v),
          },
        ],
      },
      {
        title: "Xuất dùng",
        children: [
          {
            title: "SL",
            align: "right",
            dataIndex: "soLuongXuatDung",
            key: "soLuongXuatDung",
            width: 50,
          },
          {
            title: "Thành tiền",
            dataIndex: "thanhTienXuatDung",
            align: "right",
            key: "thanhTienXuatDung",
            width: 100,
            render: (v) => formatToCurrencyType(v),
          },
        ],
      },
      {
        title: "Xuất trả nhà cung cấp",
        children: [
          {
            title: "SL",
            align: "right",
            dataIndex: "soLuongXuatTraNcc",
            key: "soLuongXuatTraNcc",
            width: 50,
          },
          {
            title: "Thành tiền",
            dataIndex: "thanhTienXuatTraNcc",
            align: "right",
            key: "thanhTienXuatTraNcc",
            width: 100,
            render: (v) => formatToCurrencyType(v),
          },
        ],
      },
      {
        title: "Xuất hết hạn",
        children: [
          {
            title: "SL",
            align: "right",
            dataIndex: "soLuongXuatHetHan",
            key: "soLuongXuatHetHan",
            width: 50,
          },
          {
            title: "Thành tiền",
            dataIndex: "thanhTienXuatHetHan",
            align: "right",
            key: "thanhTienXuatHetHan",
            width: 100,
            render: (v) => formatToCurrencyType(v),
          },
        ],
      },
      {
        title: "Khác",
        children: [
          {
            title: "SL",
            dataIndex: "soLuongKhacXuat",
            align: "right",
            key: "soLuongKhacXuat",
            width: 50,
          },
          {
            title: "Thành tiền",
            dataIndex: "thanhTienKhacXuat",
            align: "right",
            key: "thanhTienKhacXuat",
            width: 100,
            render: (v) => formatToCurrencyType(v),
          },
        ],
      },
    ],
  },
  {
    title: "Tồn cuối kỳ",
    children: [
      {
        title: "SL",
        width: 50,
        align: "right",
        key: "soLuongTonCuoi",
        dataIndex: "soLuongTonCuoi",
      },
      {
        title: "Thành tiền",
        width: 100,
        align: "right",
        key: "thanhTienTonCuoi",
        render: (v) => formatToCurrencyType(v),
        dataIndex: "thanhTienTonCuoi",
      },
    ],
  },
];

export { allReportAllColums, allStoreFields };
